import { render, staticRenderFns } from "./CategorySearch.vue?vue&type=template&id=28020769&scoped=true"
import script from "./CategorySearch.vue?vue&type=script&lang=js"
export * from "./CategorySearch.vue?vue&type=script&lang=js"
import style0 from "./CategorySearch.vue?vue&type=style&index=0&id=28020769&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28020769",
  null
  
)

export default component.exports